import { useContext, useEffect } from "react";
import { Context as BreadcrumbContext } from "./Provider";

interface Path {
  name: string;
  link?: string;
}

export const Breadcrumb: React.FC<{ paths: Path[] }> = ({ paths }) => {
  const breadcrumbContext = useContext(BreadcrumbContext);

  useEffect(() => {
    breadcrumbContext.setBreadcrumb(paths);
  }, [paths]);

  return null;
};
